/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Link } from "react-router-dom"; // ✅ Import Link

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

import styles from "assets/jss/material-dashboard-pro-react/components/footerStyle.js";

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  const { fluid, white, rtlActive } = props;

  const container = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white,
  });

  const anchor = classes.a + cx({ [" " + classes.whiteColor]: white });
  const block = cx({ [classes.block]: true, [classes.whiteColor]: white });

  return (
    <footer className={classes.footer}>
      <div
        className={container}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <div className={classes.left} style={{ marginBottom: 12 }}>
          <List
            className={classes.list}
            style={{ display: "flex", justifyContent: "center", padding: 0 }}
          >
            <ListItem
              className={classes.inlineBlock}
              style={{ display: "inline-block" }}
            >
              <Link to="/auth/privacy-policy" className={block}>
                {rtlActive ? "سياسة الخصوصية" : "Privacy Policy"}
              </Link>
            </ListItem>
            <ListItem
              className={classes.inlineBlock}
              style={{ display: "inline-block" }}
            >
              <Link to="/auth/terms-of-use" className={block}>
                {rtlActive ? "شروط الاستخدام" : "Terms of Use"}
              </Link>
            </ListItem>
            <ListItem
              className={classes.inlineBlock}
              style={{ display: "inline-block" }}
            >
              <Link to="/auth/affiliate-policy" className={block}>
                {rtlActive ? "سياسة الشركاء" : "Affiliates Terms"}
              </Link>
            </ListItem>
          </List>
        </div>
        <p className={classes.right} style={{ margin: 0 }}>
          &copy; {1900 + new Date().getYear()}{" "}
          <Link to="/" className={anchor}>
            {rtlActive ? "برامور" : "Beramour"}
          </Link>
        </p>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  fluid: PropTypes.bool,
  white: PropTypes.bool,
  rtlActive: PropTypes.bool,
};
